import { z } from "zod";

const CreateBoardSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: "Name is required." })
      .max(400, { message: "Name must be less than 400 characters." }),
    description: z
      .string()
      .max(2000, { message: "Description must be less than 2000 characters." })
      .optional(),
  })
  .strict();

export default CreateBoardSchema;
